import { Navigate } from 'react-router-dom';
import { useStore } from '@store/GlobalStore';
import { shallow } from 'zustand/shallow';
import { ReactElement } from 'react';

export const PaymentPortalGuard = ({ children }: { children: ReactElement }) => {
  const [currentUser, isInternalUser] = useStore(
    (state) => [state.currentUser, state.userAuth.isInternalUser],
    shallow,
  );

  const hasPayerAccount = !!currentUser?.payer?.id;

  if (!hasPayerAccount && !isInternalUser) {
    return <Navigate to='/payments/add-account' />;
  }

  return children;
};
